/**
 * AI Gateway · IDE onboarding page (Sprint 365 Stream A; REQ-GW-015).
 *
 * Dedicated surface for "Connect your IDE". The onboarding card no longer
 * lives inside the applications page: navigation order is applications/keys →
 * IDE → policy, so the endpoint and snippets have their own entry.
 */

import { Laptop } from 'lucide-react';
import { PageHeader } from '@vanguard-atlas/shared';
import { useI18n } from '@/i18n';
import { ConnectIdeCard } from '../components/ConnectIdeCard';

export function GatewayIdePage() {
  const { t } = useI18n();

  return (
    <div className="p-6 space-y-6" data-testid="gateway-ide-page">
      <PageHeader
        icon={Laptop}
        title={t('gateway.ide.title')}
        subtitle={t('gateway.ide.subtitle')}
        testId="gateway-ide-header"
      />
      <ConnectIdeCard />
    </div>
  );
}
